"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureToggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useFeatureToggles = require("./useFeatureToggles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/** @deprecated Use the `FeatureToggleComponentProps` interface from the `@ori/feature-toggles` library */

/** @deprecated Use the `FeatureToggleProps` interface from the `@ori/feature-toggles` library */

/**
 *
 * @param feature Feature to toggle.
 * @param children Children
 * @param additionalCondition Optional condition to check for to to render **On** switch.
 * @returns
 *
 * @deprecated Use the `FeatureToggle` component from the `@ori/feature-toggles` library
 */
const FeatureToggle = ({
  children,
  feature,
  additionalCondition
}) => {
  const {
    isFeatureEnabled
  } = (0, _useFeatureToggles.useFeatureToggles)();

  // if additional condition was provided, then the rendering of the On switch depends also on this, condition and not just turned on feature toggle.
  const isEnabled = isFeatureEnabled(feature) && (additionalCondition ?? true);
  const toggledChildren = _react.default.Children.map(children, child => /*#__PURE__*/(0, _react.cloneElement)(child, {
    isEnabled
  }));

  // eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: toggledChildren
  });
};
exports.FeatureToggle = FeatureToggle;
